import { useState } from "react";
import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import MovieCard from "@/components/feature/MovieCard";

interface LatestUpdatesProps {
  movies: Movie[];
  tvShows: Movie[];
}

export default function LatestUpdates({ movies, tvShows }: LatestUpdatesProps) {
  const [tab, setTab] = useState<"movie" | "tv">("movie");
  const list = tab === "movie" ? movies : tvShows;

  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 pt-12 md:px-8 md:pt-16">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          <span className="h-6 w-1.5 rounded-full bg-accent-500" />
          最新更新
        </h2>
        <div className="flex items-center gap-1 rounded-full bg-background-200 p-1">
          <button
            type="button"
            onClick={() => setTab("movie")}
            className={`rounded-full px-5 py-1.5 text-sm font-medium transition-colors ${
              tab === "movie" ? "bg-primary-500 text-background-50" : "text-foreground-600 hover:text-foreground-950"
            }`}
          >
            最新电影
          </button>
          <button
            type="button"
            onClick={() => setTab("tv")}
            className={`rounded-full px-5 py-1.5 text-sm font-medium transition-colors ${
              tab === "tv" ? "bg-primary-500 text-background-50" : "text-foreground-600 hover:text-foreground-950"
            }`}
          >
            最新剧集
          </button>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 md:gap-5">
        {list.slice(0, 12).map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>

      <div className="mt-8 flex justify-center">
        <Link
          to={tab === "movie" ? "/category/movie" : "/category/tv"}
          className="flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-6 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-100"
        >
          查看更多{tab === "movie" ? "电影" : "剧集"}
          <i className="ri-arrow-right-line text-base" />
        </Link>
      </div>
    </section>
  );
}